import { db } from "../firebase/firebase";
import toast from "toastr";
import Endpoint from "../Endpoint";
import axios from "axios";
export const ADD_NEW_DOCUMENTS = "ADD_NEW_DOCUMENTS";
export const ADD_NEW_DOCUMENTS_ERR = "ADD_NEW_DOCUMENTS_ERR";
// get
export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const GET_DOCUMENTS_ERR = "GET_DOCUMENTS_ERR";

export const GET_AUTOPOPULATE = "GET_AUTOPOPULATE";
export const GET_AUTOPOPULATE_ERR = "GET_AUTOPOPULATE_ERR";

export const GET_UNVERIFIEDDOCUMENTS = "GET_UNVERIFIEDDOCUMENTS";
export const GET_UNVERIFIEDDOCUMENTS_ERR = "GET_UNVERIFIEDDOCUMENTS_ERR";

export const GET_TEMPLATESCHEMA = "GET_TEMPLATESCHEMA";
export const GET_TEMPLATESCHEMA_ERR = "GET_TEMPLATESCHEMA_ERR";

export const GET_SINGLEEMPLOYEE = "GET_SINGLEEMPLOYEE";
export const GET_SINGLEEMPLOYEER = "GET_SINGLEEMPLOYEER";

export const ADD_NEW_UNVERIFIED_DOCUMENTS = "ADD_NEW_UNVERIFIED_DOCUMENTS";

export function addNewDocuments(data) {
  return dispatch => {
    axios
      .post(`${Endpoint}/formapi/createTemplate`, data, {
        headers: {
          "Content-Type": `multipart/form-data`
        }
      })
      .then(res => {
        console.log("res", res);

        if (res.data.id) {
          let datatodb = {
            orignalFileName: res.data.orignalFileName,
            doc_name: res.data.name,
            template_id: res.data.id,
            status: "unverified",
            createdAt: `${new Date()}`
          };

          db.collection("systemdocuments")
            .add(datatodb)
            .then(function(docRef) {
              toast.success("Succefully add System documents");
              dispatch({
                type: ADD_NEW_DOCUMENTS
              });
            })
            .catch(function(error) {
              toast.error("Error occured. Please try again later");
              dispatch({
                type: ADD_NEW_DOCUMENTS_ERR
              });
            });
        } else {
          console.error("err", res.data);
          // toast.error("Please choose an editable pdf!");
          dispatch({
            type: ADD_NEW_DOCUMENTS_ERR
          });
        }
      })
      .catch(err => {
        console.error(err);
        dispatch({
          type: ADD_NEW_DOCUMENTS_ERR
        });
        toast.error("Error Has been Occoured!");
      });
  };
}

// Get all task
export function getSystemDocuments() {
  return dispatch => {
    db.collection("systemdocuments")
      .where("status", "==", "verified")
      .onSnapshot(
        function(querySnapshot) {
          let datatoStore = [];
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            let doc_id = doc.id;
            let final = {
              ...data,
              doc_id
            };

            datatoStore.push(final);
          });

          dispatch({
            type: GET_DOCUMENTS,
            payload: datatoStore
          });
        },
        function(err) {
          dispatch({
            type: GET_DOCUMENTS_ERR
          });
        }
      );
  };
}

export function getUnverifiedDocuments() {
  return dispatch => {
    db.collection("systemdocuments")
      // .select('documnentName')
      .where("status", "==", "unverified")
      .onSnapshot(
        function(querySnapshot) {
          let datatoStore = [];
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            let doc_id = doc.id;
            let final = {
              ...data,
              doc_id
            };

            datatoStore.push(final);
          });

          dispatch({
            type: GET_UNVERIFIEDDOCUMENTS,
            payload: datatoStore
          });
        },
        function(err) {
          dispatch({
            type: GET_UNVERIFIEDDOCUMENTS_ERR
          });
        }
      );
  };
}

export function addVerifiedDocuments(data) {
  return dispatch => {
    db.collection("systemdocuments")
      .doc(data.doc_id)
      .update(data.record)
      .then(function(docRef) {
        toast.success("Successfully add verified System documents");
        dispatch({
          type: ADD_NEW_UNVERIFIED_DOCUMENTS
        });
      })
      .catch(function(error) {
        toast.error("Error occured. Please try again later");
        dispatch({
          type: ADD_NEW_UNVERIFIED_DOCUMENTS
        });
      });
  };
}

export function getAutoPopulate() {
  return dispatch => {
    db.collection("autopopulate")
      // .select('documnentName')
      .onSnapshot(
        function(querySnapshot) {
          let datatoStore = {};
          querySnapshot.forEach(function(doc) {
            const data = doc.data();
            datatoStore = data;
          });
          console.log(" autopopulate", datatoStore);

          dispatch({
            type: GET_AUTOPOPULATE,
            payload: datatoStore
          });
        },
        function(err) {
          dispatch({
            type: GET_AUTOPOPULATE_ERR
          });
        }
      );
  };
}

export function getSingleEmployeeForTesting() {
  return dispatch => {
    db.collection("employees")
      .orderBy("createdAt", "desc") // Order documents by added_at field in
      .limit(1)
      .get()
      .then(function(prevSnapshot) {
        let datatoStore = {};
        prevSnapshot.forEach(function(doc) {
          const data = doc.data();
          datatoStore = data;
        });
        console.log("single Employee", datatoStore);

        dispatch({
          type: GET_SINGLEEMPLOYEE,
          payload: datatoStore
        });
      });
  };
}
export function getSingleEmployerForTesting() {
  return dispatch => {
    db.collection("employers")
      .orderBy("createdAt", "desc") // Order documents by added_at field in
      .limit(1)
      .get()
      .then(function(prevSnapshot) {
        let datatoStore = {};
        prevSnapshot.forEach(function(doc) {
          const data = doc.data();
          datatoStore = data;
        });
        console.log("single Employer", datatoStore);

        dispatch({
          type: GET_SINGLEEMPLOYEER,
          payload: datatoStore
        });
      });
  };
}

export function getTemplateSchema(id) {
  console.log("id get", id);

  return dispatch => {
    axios
      .post(`${Endpoint}/formapi/getTemplateSchema`, { id: id })
      .then(res => {
        console.log("res", res.data);

        if (res.data.properties) {
          let datatoStore = {
            ...res.data,
            template_id: id
          };
          dispatch({
            type: GET_TEMPLATESCHEMA,
            payload: datatoStore
          });
        } else {
          console.error("err", res.data);
          toast.error("Error Has been Occoured! Try again later");
          dispatch({
            type: GET_TEMPLATESCHEMA_ERR
          });
        }
      })
      .catch(err => {
        console.error(err);
        dispatch({
          type: GET_TEMPLATESCHEMA_ERR
        });
        toast.error("Error Has been Occoured! Try agin later");
      });
  };
}

